import React from 'react';
import { Star, Instagram } from 'lucide-react';
import { motion } from 'framer-motion';
export function SocialProof() {
  const quotes = ['Resultados súper naturales ✨', 'La mejor atención en Montevideo', 'Me cambió la piel por completo', 'Profesionalismo absoluto', 'Mi lugar de confianza', 'Resultados súper naturales ✨', 'La mejor atención en Montevideo', 'Me cambió la piel por completo'];
  return <section className="bg-white border-y border-rosegold/10 py-6 overflow-hidden flex flex-col items-center" data-id="element-137">
      <div className="flex items-center gap-2 mb-4" data-id="element-138">
        <div className="flex gap-1 text-rosegold" data-id="element-139">
          {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-140" />)}
        </div>
        <span className="text-sm font-medium text-charcoal px-2 border-r border-charcoal/20" data-id="element-141">
          Más de 30.000 seguidores confían en Mantra
        </span>
        <a href="#" className="text-rosegold hover:text-rosegold-600 transition-colors ml-1" data-id="element-142">
          <Instagram size={18} data-id="element-143" />
        </a>
      </div>

      {/* Marquee */}
      <div className="w-full relative flex overflow-x-hidden" data-id="element-144">
        <motion.div className="flex whitespace-nowrap gap-8 px-4" animate={{
        x: ['0%', '-50%']
      }} transition={{
        repeat: Infinity,
        ease: 'linear',
        duration: 20
      }} data-id="element-145">
          {quotes.map((quote, i) => <span key={i} className="text-sm text-charcoal/50 font-serif italic" data-id="element-146">
              "{quote}"
            </span>)}
        </motion.div>
      </div>
    </section>;
}